const translations = {
    confirmDeleteFaaReport: 'Delete FAA Report?',
    confirmDeleteFaaReportMessage: 'Are you sure you want to delete this FAA report?',
    confirmDeleteFaaReportSubtextMessage: 'This action cannot be undone.'
};

export default translations;
